import * as apiClient from '../api/apiClient';
import { unwrapResponseModel } from '../api/responseModel';

export async function changePassword(payload) {
  const { data } = await apiClient.post('/api/user/change-password', payload);
  return unwrapResponseModel(data);
}
